export const LOGIN_ROUTE = '/login';
/** `tenantLegacyRedirectGuard` sends each user on: their tenant, the admin or their account. */
export const HOME_ROUTE = '/tenant';
